.h1{border:1px solid #ddd;}